












import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'

@Component({
  components: {
  },
})
export default class LineCell extends Vue 
{
    @Prop() private selected! : boolean;
    @Prop() private line! : { type : string }

    private get buttonImage()
    {
        var image = "";
        if(this.line.type == "line") { image = "./resources/lineButton.svg"; }
        else if(this.line.type == "curve") { image = "./resources/curveButton.svg"}
        return image;
    }

    private onClick()
    {
        this.$emit("select");
    }
   
}
